export default "__VITE_ASSET__BL4m9VfF__"